import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, ShieldCheck, MessageCircle } from 'lucide-react';

const LOGO_WITH_TEXT = "https://customer-assets.emergentagent.com/job_webisula-digital/artifacts/c7jpgwxe_Capture%20d%E2%80%99e%CC%81cran%202026-05-15%20a%CC%80%2013.22.18.png";

const CardIcons = () => (
  <div className="flex items-center gap-2" data-testid="footer-card-icons">
    {/* Visa */}
    <svg className="h-8 w-12 rounded bg-white/10 p-1" viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#1A1F71"/>
      <path d="M19.5 21H17L18.8 11H21.3L19.5 21ZM15.2 11L12.8 18L12.5 16.5L11.6 12C11.6 12 11.5 11 10.2 11H6.1L6 11.2C6 11.2 7.5 11.5 9.2 12.5L11.4 21H14L18 11H15.2ZM35.5 21H38L35.8 11H33.8C32.7 11 32.4 11.8 32.4 11.8L28.5 21H31.1L31.6 19.5H34.8L35.1 21H35.5ZM32.4 17.5L33.8 13.5L34.5 17.5H32.4ZM28.5 13.5L28.9 11.2C28.9 11.2 27.5 10.7 26 10.7C24.4 10.7 21 11.4 21 14.2C21 16.8 24.6 16.8 24.6 18.2C24.6 19.6 21.4 19.3 20.1 18.3L19.7 20.7C19.7 20.7 21.1 21.3 23 21.3C24.9 21.3 28.4 20.2 28.4 17.7C28.4 15.1 24.7 14.9 24.7 13.7C24.7 12.5 27.1 12.6 28.5 13.5Z" fill="white"/>
    </svg>
    {/* Mastercard */}
    <svg className="h-8 w-12 rounded bg-white/10 p-1" viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#252525"/>
      <circle cx="19" cy="16" r="9" fill="#EB001B"/>
      <circle cx="29" cy="16" r="9" fill="#F79E1B"/>
      <path d="M24 9.3A9 9 0 0 0 20 16a9 9 0 0 0 4 6.7A9 9 0 0 0 28 16a9 9 0 0 0-4-6.7Z" fill="#FF5F00"/>
    </svg>
    {/* Amex */}
    <svg className="h-8 w-12 rounded bg-white/10 p-1" viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#2E77BC"/>
      <text x="24" y="13" textAnchor="middle" fill="white" fontSize="5" fontWeight="bold" fontFamily="Arial, sans-serif">AMERICAN</text>
      <text x="24" y="19" textAnchor="middle" fill="white" fontSize="5" fontWeight="bold" fontFamily="Arial, sans-serif">EXPRESS</text>
      <rect x="4" y="22" width="40" height="1" fill="white" opacity="0.4"/>
    </svg>
    {/* CB */}
    <svg className="h-8 w-12 rounded bg-white/10 p-1" viewBox="0 0 48 32" fill="none">
      <rect width="48" height="32" rx="4" fill="#1D6D37"/>
      <rect x="6" y="8" width="36" height="7" rx="2" fill="#004E94"/>
      <rect x="6" y="17" width="36" height="7" rx="2" fill="#009E49"/>
      <text x="24" y="14" textAnchor="middle" fill="white" fontSize="6" fontWeight="bold" fontFamily="Arial">CB</text>
    </svg>
  </div>
);

export const Footer = () => {
  return (
    <footer className="bg-[#0C0514] border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <div className="mb-6 flex items-center gap-2.5" data-testid="footer-logo">
              <img 
                src="https://customer-assets-jt897jd0.emergentagent.net/job_webisula-digital/artifacts/fabbc332efdcbb6a_sphere.png" 
                alt="" 
                className="h-12 w-auto sphere-spin"
              />
              <span className="text-3xl font-black tracking-tight">
                <span className="text-white">WEB</span><span className="text-[#8B5A8B]">ISULA</span>
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Agence web corse spécialisée dans la création de sites internet et applications nouvelle génération.
            </p>
            <div className="mt-4">
              <Link 
                to="/contact" 
                className="glow-btn inline-flex items-center gap-2 text-sm px-6 py-3"
                data-testid="footer-contact-btn"
              >
                <MessageCircle size={16} />
                Nous contacter
              </Link>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-semibold mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/60 hover:text-white text-sm transition-colors" data-testid="footer-link-accueil">Accueil</Link></li>
              <li><Link to="/services" className="text-white/60 hover:text-white text-sm transition-colors" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/portfolio" className="text-white/60 hover:text-white text-sm transition-colors" data-testid="footer-link-portfolio">Réalisations</Link></li>
              <li><Link to="/tarifs" className="text-white/60 hover:text-white text-sm transition-colors" data-testid="footer-link-tarifs">Tarifs</Link></li>
              <li><Link to="/contact" className="text-white/60 hover:text-white text-sm transition-colors" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services#vitrine" className="text-white/60 hover:text-white text-sm transition-colors">Sites Vitrine</Link></li>
              <li><Link to="/services#ecommerce" className="text-white/60 hover:text-white text-sm transition-colors">E-Commerce</Link></li>
              <li><Link to="/services#mobile" className="text-white/60 hover:text-white text-sm transition-colors">Applications Mobiles</Link></li>
              <li><Link to="/services#saas" className="text-white/60 hover:text-white text-sm transition-colors">Plateformes SaaS</Link></li>
              <li><Link to="/services#parrainage" className="text-white/60 hover:text-white text-sm transition-colors">Solutions Marketing</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#8B5A8B] mt-0.5 flex-shrink-0" />
                <span className="text-white/60 text-sm">Ajaccio, Corse</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#8B5A8B] flex-shrink-0" />
                <a href="tel:0759948289" className="text-white/60 hover:text-white text-sm transition-colors" data-testid="footer-phone">
                  07 59 94 82 89
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-white/40 text-sm" data-testid="footer-copyright">
            © {new Date().getFullYear()} Webisula. Tous droits réservés.
          </p>
          <div className="flex space-x-6">
            <Link to="/mentions-legales" className="text-white/40 hover:text-white text-sm transition-colors">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="text-white/40 hover:text-white text-sm transition-colors">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
